import { render, staticRenderFns } from "./EventsControls.vue?vue&type=template&id=5b837b89&scoped=true"
import script from "./EventsControls.vue?vue&type=script&lang=js"
export * from "./EventsControls.vue?vue&type=script&lang=js"
import style0 from "./EventsControls.vue?vue&type=style&index=0&id=5b837b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b837b89",
  null
  
)

export default component.exports